import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4cd35177")

_pushScopeId("data-v-4cd35177")
const _hoisted_1 = {
  key: 0,
  class: "percentage-2 px-3"
}
const _hoisted_2 = {
  key: 1,
  class: "percentage-2 px-3"
}
const _hoisted_3 = {
  key: 2,
  class: "percentage-2 px-3"
}
const _hoisted_4 = {
  key: 3,
  class: "percentage-2 px-3"
}
const _hoisted_5 = { style: {"white-space":"nowrap"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("span", {
      style: { color: $setup.percentage ? '#ffcc00' : '#597dfe' }
    }, [
      _createVNode("b", {
        style: {"white-space":"nowrap"},
        id: 'advance-' + $props.element.id
      }, _toDisplayString($setup.percentage
          ? $props.element.advance.toFixed(0)
          : $props.element.relativeAdvance.toFixed(0)) + "% ", 9, ["id"])
    ], 4),
    (
      $props.element.type !== 'key_result' &&
        $props.element.currentValue &&
        $props.element.targetValue &&
        $props.element.targetValue > 0
    )
      ? (_openBlock(), _createBlock("span", _hoisted_1, [
          _createVNode("b", {
            style: {"white-space":"nowrap"},
            id: 'current_value-' + $props.element.id
          }, _toDisplayString(`${
          $setup.cycle == 0
            ? 0
            : $setup.percentage
            ? (($props.element.currentValue / $props.element.targetValue) * 100).toFixed(0)
            : (
                (($props.element.currentValue / $props.element.targetValue) * 100) /
                $setup.cycle
              ).toFixed(0)
        }%${$setup.translate("theEfect")}`), 9, ["id"])
        ]))
      : (
      $props.element.type !== 'key_result' &&
        $props.element.targetValue &&
        $props.element.currentValue &&
        $props.element.currentValue > 0
    )
        ? (_openBlock(), _createBlock("span", _hoisted_2, [
            _createVNode("b", {
              style: {"white-space":"nowrap"},
              id: 'current_value-' + $props.element.id
            }, _toDisplayString(`${
          $setup.cycle == 0
            ? 0
            : $setup.percentage
            ? (($props.element.targetValue / $props.element.currentValue) * 100).toFixed(0)
            : (
                (($props.element.targetValue / $props.element.currentValue) * 100) /
                $setup.cycle
              ).toFixed(0)
        }%${$setup.translate("theEfect")}`), 9, ["id"])
          ]))
        : ($props.element.type !== 'key_result')
          ? (_openBlock(), _createBlock("span", _hoisted_3, [
              _createVNode("b", {
                style: {"white-space":"nowrap"},
                id: 'current_value-' + $props.element.id
              }, _toDisplayString(`0%${$setup.translate("theEfect")}`), 9, ["id"])
            ]))
          : _createCommentVNode("", true),
    ($props.element.type === 'key_result')
      ? (_openBlock(), _createBlock("span", _hoisted_4, [
          _createVNode("b", _hoisted_5, _toDisplayString($props.element.currentValue) + _toDisplayString(" " + $props.element.unit), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
})